export enum AgentConversationStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum AgentMessageRole {
  USER = 'USER',
  ASSISTANT = 'ASSISTANT',
}

export enum AgentMessageStatus {
  PENDING = 'PENDING',
  STREAMING = 'STREAMING',
  AWAITING_CONFIRMATION = 'AWAITING_CONFIRMATION',
  EXECUTING = 'EXECUTING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum AgentMode {
  ASK = 'ASK',
  PLAN = 'PLAN',
  AGENT = 'AGENT',
}

export enum AgentModelProvider {
  ANTHROPIC = 'ANTHROPIC',
  OPENAI = 'OPENAI',
  GOOGLE = 'GOOGLE',
}

export enum AgentTimelineBlockType {
  THINKING = 'THINKING',
  TEXT = 'TEXT',
  TOOL_CALL = 'TOOL_CALL',
  PLAN = 'PLAN',
  ERROR = 'ERROR',
  CLARIFY = 'CLARIFY',
}

export enum AgentTimelineBlockStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
